@if (followUps().length > 0) {
    <div class="follow-ups">
        @if (heading()) {
            <span class="follow-ups__heading">{{ heading() }}</span>
        }
        <ul class="follow-ups__list">
            @for (followUp of followUps(); track followUp.question) {
                <li class="follow-ups__item">
                    <button
                        type="button"
                        class="follow-ups__button"
                        [attr.aria-label]="followUp.title"
                        (click)="onSelect(followUp)"
                    >
                        <i class="fa-solid fa-arrow-turn-up follow-ups__icon"></i>
                        <span class="follow-ups__title">{{ followUp.title }}</span>
                    </button>
                </li>
            }
        </ul>
    </div>
}
